import { PrimaryButton } from "@certn/cascadia-react";
import { components } from "@certn/legacy-api/generated-schemas/people";
import { Trans } from "react-i18next";
import { array } from "yup";

import { IdentificationDocumentsInputField } from "./IdentificationDocumentsInputField";
import { IdentificationDocumentsSummaryField } from "./IdentificationDocumentsSummaryField";
import { IncompleteDocumentsModal } from "./IncompleteDocumentsModal";
import { getNumMissingDocuments } from "./utils";
import { FieldType } from "../types";

export function IdentificationDocumentsField(
  field: components["schemas"]["IdentificationDocumentsCheckField"]
): FieldType<components["schemas"]["IdentificationDocumentsCheckField"]> {
  return {
    field,
    inputElement: (
      <IdentificationDocumentsInputField key={field.name} field={field} />
    ),
    summaryElement: () => (
      <IdentificationDocumentsSummaryField key={field.name} field={field} />
    ),
    initialValue: field.value,
    schema: identifiationDocumentsSchema,
    saveButtonOverride: ({ values, submitFormWithoutValidation }) => {
      if (getNumMissingDocuments(values[field.name])) {
        return (
          <IncompleteDocumentsModal
            key={field.name + "_presave_modal"}
            documents={values[field.name]}
            onNext={submitFormWithoutValidation}
            trigger={
              <PrimaryButton size="medium">
                <Trans>Next step</Trans>
              </PrimaryButton>
            }
          />
        );
      }
      return undefined;
    },
  };
}

export const identifiationDocumentsSchema = array().test(
  "All documents uploaded",
  "Identification documents are incomplete",
  (values) =>
    getNumMissingDocuments(
      values as components["schemas"]["IdentificationDocumentsCheckField"]["value"]
    ) === 0
);
